import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Constants } from 'src/app/app.constants';

@Component({
  selector: 'app-option-control',
  templateUrl: './option-control.component.html',
  styleUrls: ['./option-control.component.css']
})
export class OptionControlComponent implements OnInit {
  @Output() public RadioChange = new EventEmitter<any>();
  @Input() type: string;
  @Input() options: any = [];
  @Input() anstext: string;
  @Input() comments = '';
  @Input() answeroptionid: number;
  @Input() public nme: string;
  @Input() public columnDisable = false;
  @Input() public horzColumn = false;

  is_sublevel = false;
  test: any;
  is_display = false;

  constructor() { }

  ngOnInit() {

  }


  public onChange(event: any, type: string) {
    if (type == Constants.Radio) {
      this.options.forEach(element => {
        if (element.isShow) {
          element.isShow = false;
        }
      });
    }
    if (event.isSublevel) {

      // Default check dropDown
      if (event.subAnswerText == '' && event.subAnswerList.length > 0) {
        event.subAnswerId = event.subAnswerList[0].nestedAnswerChoiceId;
        event.subAnswerText = event.subAnswerId.toString();
      }

      // Hide/Show Sublevel Answers
      if (event.isChecked && type == Constants.Check) {
        event.isShow = true;
      } else if (type == Constants.Radio) {
        event.isShow = true;
      } else {
        event.isShow = false;
      }

    }
    if (type == Constants.Submenu) {
      if (event.answerText == Constants.Other) {
        event.subChoiceOtherOption = true;

      } else {
        this.options.forEach(element => {
          if (element.isSublevel) {

            element.subAnswerList.forEach(ele => {
              if (ele.subChoiceOtherOption) {
                ele.subChoiceOtherOption = false;
                ele.remarks = '';
              }

            });


          }
        });

      }
    }


    // Emitevent onchange
    const values = {
      event, type
    };
    this.RadioChange.emit(values);
  }


}
